import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"outlined":"","label":_vm.$t('Discount description'),"hide-details":"auto"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }